import { observer } from 'mobx-react-lite'
import { Fragment, useEffect } from 'react'
import { EmptyState, type IRow } from 'shared/ui'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { getCallingActions } from 'pages/chatbot/pages/calling/actions/getCallingActions'
import { useListLayoutContext } from 'pages/chatbot/layout/ListLayout/context'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { useCallingContext } from '../context'
import styles from './styles.module.scss'
import { columns } from './colums'
import { type CallingListItem } from '../store/CallingListItem'

export const CallingUI = observer(() => {
  const { disabledLoadingOnMount } = useListLayoutContext()
  const { search, setSearch, isEmpty, items, tableStore, loadData, onSuccessDelete } =
    useCallingContext()
  const rows = items.map((item) => {
    item.setActionsProps({
      actions: getCallingActions({
        item: item.origin,
        onSuccessDelete: () => onSuccessDelete(item.id),
        onSuccessUpdate: item.syncOrigin,
      }),
    })

    return item
  })
  useEffect(() => {
    if (!disabledLoadingOnMount) {
      loadData()
    }
  }, [])

  const getRowLink = (row: IRow<CallingListItem>) => ChatbotPath.callingView(row.id)
  return (
    <div className={styles.container}>
      {isEmpty ? (
        <EmptyState variant='default' text='No calling agents' noIcon />
      ) : (
        <>
          <div className={styles.search}>
            <TableSearch value={search} onChange={setSearch} />
          </div>

          <div className={styles.table}>
            <Table
              ariaLabel={tableStore.config.key}
              store={tableStore}
              rows={rows}
              columns={columns}
              pinnedColumnIds={['name']}
              rightHeaderContent={<Fragment />}
              getRowLink={getRowLink}
            />
          </div>
        </>
      )}
    </div>
  )
})
